import React from "react";
import { IconType } from "react-icons";
import { useSelector } from "react-redux";
import { FaDollarSign } from "react-icons/fa6";
import { IoMdCart } from "react-icons/io";
import { useNavigate } from "react-router-dom";

interface EarningCardProp {
  title: string;
  amount: string;
  icon: IconType;
  iconColor: string;
  iconBgColor: string;
}
function EarningCard({
  title,
  amount,
  icon,
  iconColor,
  iconBgColor,
}: EarningCardProp) {
  return (
    <div className="p-4 bg-white gap-4 flex justify-between items-center">
      <div className="flex flex-col gap-2">
        <p className="text-[#989898]  font-Source text-xs uppercase font-normal tracking-[1.017px]">
          {title}
        </p>
        <p className="text-[#484848] font-Source text-sm lg:text-2xl tracking-[0.509px] font-normal ">
          ${amount}
        </p>
      </div>
      <div
        className={`p-3 rounded-sm `}
        style={{
          backgroundColor: iconBgColor,
        }}
      >
        {icon({ size: 25, color: iconColor })}
      </div>
    </div>
  );
}

const UserDetails = () => {
  const user = useSelector((state: any) => state.user.userDetails);

  const type = useSelector((state: any) => state.dashboardState.dashboardType);

  // console.log(type);

  const navigate = useNavigate();
  return (
    <div className="w-full flex-col gap-7 lg:flex-row lg:gap-0  flex justify-between lg:items-center">
      <div className="flex flex-col gap-1">
        <span className=" text-xs lg:text-lg text-lightGreyText font-Inter">
          Welcome,
        </span>
        <p className="text-[#01150C] font-Inter text-lg lg:text-2xl font-black leading-10">
          {/* TODO: Remove the new user */}
          {user?.firstName ?? "New"} {user?.lastName ?? "User"}
        </p>
      </div>
      <div className="flex gap-[12px]   ">
        {type === "lessee" ? (
          <button
            type="button"
            className={`font-Poppins text-center text-[13px] font-semibold text-white px-7 py-3 border rounded-md bg-midGreen ${
              user?.userOnboardingStatus !== "VerifyDriverLicense"
                ? "cursor-not-allowed hover:bg-midGreen/70"
                : "cursor-pointer"
            }`}
            disabled={user?.userOnboardingStatus !== "VerifyDriverLicense"}
            onClick={() => navigate("/vehicles")}
          >
            Rent a Vehicle
          </button>
        ) : (
          <button
            type="button"
            className={`font-Poppins text-center text-[13px] font-semibold text-white px-7 py-3 border rounded-md bg-midGreen`}
            // disabled={user?.userOnboardingStatus !== "VerifyDriverLicense"}
            onClick={() => navigate("/vehicles/add")}
          >
            List a Vehicle
          </button>
        )}

        {/* <EarningCard
          title="Total Earning"
          amount="9,000"
          icon={FaDollarSign}
          iconColor="#88B267"
          iconBgColor="#EEF3E9"
        />
        <EarningCard
          title="Orders"
          amount="22,220"
          icon={IoMdCart}
          iconColor="#5DBED3"
          iconBgColor="#DBF0F4"
        /> */}
      </div>
    </div>
  );
};

export default UserDetails;
